import { createSelector } from 'reselect';

import { isUserColumnMdSize, subscriptionColumnSize } from '../utils/subscriptionWidth';
import { validate } from '../utils/utils';

import State from '../../../interfaces/states/State';

import Validated from '../interfaces/Validated';
import AvailablePackage from '../interfaces/AvailablePackage';
import FinishedForm from '../interfaces/FinishedForm';
import ExistSubscription from '../interfaces/ExistSubscription';
import Message from '../interfaces/Message';

import { GridSize } from '@material-ui/core/es/Grid';
import { SubscriptionPeriod } from 'components/constants';

export const product$ = (state: State): string => state.subscription.product;
export const package$ = (state: State): string => state.subscription.package_;
export const dateTo$ = (state: State): Date => state.subscription.dateTo;
export const dateFrom$ = (state: State): Date => state.subscription.dateFrom;
export const dateError$ = (state: State): string => state.subscription.dateError;
export const typePayment$ = (state: State): string => state.subscription.typePayment;
export const planePrice$ = (state: State): string | number => state.subscription.planePrice;
export const fieldsArea$ = (state: State): string => state.subscription.fieldsArea;
export const subscriptionPeriod$ = (state: State): SubscriptionPeriod => state.subscription.subscriptionPeriod;
export const shouldCreatePayment$ = (state: State): boolean => state.subscription.shouldCreatePayment;
export const isFormReady$ = (state: State): boolean => state.subscription.formReady;

export const validatedForm$ = createSelector(
  product$, package$, dateFrom$, dateTo$, typePayment$, planePrice$, fieldsArea$,
  (
    product,
    package_,
    dateFrom,
    dateTo,
    typePayment,
    planePrice,
    fieldsArea
  ): Validated => {
    return validate({ product, package_, dateFrom, dateTo, typePayment, planePrice, fieldsArea });
  }
);

export const availableProduct$ = (state: State): string[] => state.subFormOptions.availableProduct;
export const availablePackage$ = (state: State): AvailablePackage[] => state.subFormOptions.availablePackage_;

export const finishedForm$ = (state: State): FinishedForm | {} => state.subFormSend.finishedForm;
export const sendingError$ = (state: State): any => state.subFormSend.error;
export const isSendingForm$ = (state: State): boolean => state.subFormSend.isSending;

export const existSubscription$ = (state: State): ExistSubscription[] => state.existSubscription.existSubscription;
export const existSubscriptionLoading$ = (state: State): boolean => state.existSubscription.isLoading;
export const existSubscriptionMessage$ = (state: State): string => state.existSubscription.message;
export const editExistSubId$ = (state: State): number => state.existSubscription.editSub.id;
export const editExistSubDatetimeFinish$ = (state: State): string | Date => state.existSubscription.editSub.datetime_finish;

const dialogWidth$ = (state: State): number => state.existSubscription.dialogWidth;

export const isUserColumnMdSize$ = createSelector(dialogWidth$,
  (dialogWidth): boolean => {
    return isUserColumnMdSize(dialogWidth);
  });

export const subscriptionColumnSize$ = createSelector(dialogWidth$,
  (dialogWidth): GridSize => {
    return subscriptionColumnSize(dialogWidth);
  });

export const toasterMessages$ = (state: State): Message[] => state.subToaster.messages;

export const isTokenUpdated$ = (state: State): boolean => state.subToaster.tokenUpdateStatus;
